import { useMutation, useQuery } from 'react-query'
import { axiosDefaultData } from 'src/service/api'
import { RefundRequestType } from 'src/types/type'

export const useNoticeListQueryData = (CmdType: number, more: number) => {
    return useQuery([CmdType, more], async () => await axiosDefaultData(CmdType, {Length: 6 * (more + 1), Offset: 0}))
}

export const useNoticeDetailQueryData = (CmdType: number, idx: number) => {
    return useQuery([CmdType, idx], async () => await axiosDefaultData(CmdType, {Idx: idx}))
}
export const useNewsListQueryData = (CmdType: number, more: number) => {
    return useQuery([CmdType, more], async () => await axiosDefaultData(CmdType, {Length: 6 * (more + 1), Offset: 0}))
}
export const useHoroScopeFortuneQueryData = (CmdType: number) => {
    return useQuery([CmdType], async () => await axiosDefaultData(CmdType, {}))
}
export const useCheckMvnoMemberDataMutation = (CmdType: number, Telecom: number, PNumber: string) => {
    return useMutation([CmdType, Telecom, PNumber], async () =>
        await axiosDefaultData(CmdType, {Telecom: Telecom , PNumber: PNumber})
    )
}
export const useTermsQueryData = (CmdType: number) => {
    return useQuery([CmdType], async () => await axiosDefaultData(CmdType, {MemberType: 1000}))
}

export const useFaqListQueryData = (CmdType: number, contstype: number, more: number) => {
    return useQuery([CmdType, contstype, more], async () =>
        await axiosDefaultData(CmdType, {ContentsType: contstype, Length: (more + 1) * 5, Offset: 0})
    )
}

export const useLetterDataQueryData = (CmdType: number, more: number) => {
    return useQuery([CmdType, more], async () =>
        await axiosDefaultData(CmdType, {Length: (more+1) * 6, Offset: 0})
    )
}
export const useSecurityQueryData = (CmdType: number) => {
    return useMutation([CmdType], async () =>
        await axiosDefaultData(CmdType, {})
    )
}

export const useLoginCertSubmitQueryData = (CmdType: number, Telecom: number, PNumber: string, AuthToken:String) => {
    return useMutation([CmdType, Telecom, PNumber], async () =>
        await axiosDefaultData(CmdType, {
            Telecom: Telecom,
            PNumber: PNumber,
            PCode: 'DATAU_HOME',
            AuthToken:AuthToken
        })
    )
}


export const useCenterSubmitQueryData = (CmdType: number, QnaType: string, Pname: string, Pnumber: string, Email: string, Title: string, Contents: string, termsQ: string) => {
    return useMutation([CmdType, QnaType, Pname, Pnumber, Email, Title, Contents, termsQ], async () =>
        await axiosDefaultData(CmdType, {
            QnAType: QnaType,
            UName: Pname,
            PNumber: Pnumber,
            Email,
            Title,
            Contents,
            Agree: termsQ
        })
    )
}

export const useCancelQueryData = (CmdType: number, Telecom: number, PNumber: string, TransID: string, ApprovalNumber: number) => {
    return useMutation([CmdType, Telecom, PNumber, TransID, ApprovalNumber], async () =>
        await axiosDefaultData(CmdType, {
            Telecom,
            PNumber,
            TranID: TransID,
            ApprovalNumber
        })
    )
}

//수정해야함
export const useJoinQueryData = (CmdType: number, Telecom: number, PNumber: string, TransID: string, ApprovalNumber: number, TermsIdx: number, Terms:number[]) => {
    return useMutation([CmdType, Telecom, PNumber, TransID, ApprovalNumber], async () =>
        await axiosDefaultData(CmdType, {
            Telecom: Telecom,
            PNumber: PNumber,
            TranID: TransID,
            ApprovalNumber:ApprovalNumber,
            TermsIdx:TermsIdx,
            TermsAgree:Terms.join(""),
            PCode: 'DATAU_HOME'
        })
    )
}

export const useLoginQueryData = (CmdType: number, PNumber: string, TransID: string, ApprovalNumber: number) => {
    return useMutation([CmdType, PNumber, TransID, ApprovalNumber], async () =>
        await axiosDefaultData(CmdType, {
            PNumber: PNumber,
            TranID: TransID,
            ApprovalNumber: ApprovalNumber
        })
    )
}

export const useRefundQueryData = (CmdType: number, PNumber: string, TranID: string, ApprovalNumber: number, ReqRefundData: RefundRequestType) => {
    return useMutation([CmdType, PNumber, TranID, ApprovalNumber, ReqRefundData], async () =>
        await axiosDefaultData(CmdType, {
            PNumber,
            TranID,
            ApprovalNumber,
            ReqRefundData
        })
    )
}

export const useCancelSecurityConfirmQueryData = (CmdType: number, TranId: any, Telecom: number, PNumber: string, CryptoNumber: string) => {
    return useMutation([CmdType, TranId, Telecom, PNumber, CryptoNumber], async () =>
        await axiosDefaultData(CmdType, {
            TranID: TranId,
            CryptoNumber: CryptoNumber,
            Telecom: Telecom,
            PNumber: PNumber,
        })
    )
}

export const useRefundSecurityConfirmQueryData = (CmdType: number, TranId: any, PNumber: string, CryptoNumber: string) => {
    return useMutation([CmdType, TranId, PNumber, CryptoNumber], async () =>
        await axiosDefaultData(CmdType, {
            TranID: TranId,
            CryptoNumber: CryptoNumber,
            PNumber: PNumber,
        })
    )
}

export const useJoinSecurityConfirmQueryData = (CmdType: number, TranId: any, Telecom: number, PNumber: string, CryptoNumber: string) => {
    return useMutation([CmdType, TranId, Telecom, PNumber, CryptoNumber], async () =>
        await axiosDefaultData(CmdType, {
            TranID: TranId,
            CryptoNumber: CryptoNumber,
            Telecom: Telecom,
            PNumber: PNumber,
        })
    )
}
export const UserPageQueryData = (CmdType: number, PNumber: string) => {
    return useQuery([CmdType, PNumber], async () =>
        await axiosDefaultData(CmdType, {PNumber: PNumber})
    )
}

export const UserSessionQueryData = (CmdType: number, PNumber: string) => {
    return useQuery([CmdType, PNumber], async () =>
        await axiosDefaultData(CmdType, {PNumber: PNumber}),
        {enabled: !!PNumber}
    )
}

export const UserLogoutQueryData = (CmdType: number, PNumber: string) => {
    return useMutation([CmdType, PNumber], async () =>
        await axiosDefaultData(CmdType, {PNumber: PNumber})
    )
}


export const useBirthDayFortuneQueryData = (CmdType: number, Gender: number, Calendar: number, BirthDay: string, BirthTime: number) => {
    return useMutation([CmdType, Gender, Calendar, BirthDay, BirthTime], async () =>
        await axiosDefaultData(CmdType, {
            Gender: Gender,
            Calendar: Calendar,
            BirthDay: BirthDay,
            BirthTime: BirthTime,
        })
    )
}
export const useLetterDetailDataQueryData = (CmdType: number, idx:number) => {
    return useQuery([CmdType, idx], async () =>
        await axiosDefaultData(CmdType, {idx:idx})
    )
}
export const useGetTermsQueryData = (CmdType: number) => {
    return useQuery([CmdType], async () => await axiosDefaultData(CmdType))
}